<script setup lang="ts">

const $attrs = useAttrs()
const props = withDefaults(defineProps<{
    colgap?: number | 'auto'
    debug?: boolean,
    w?: string
  }>(), { w: '', debug: false })

const filteredAttrs = computed(() => {
  const myAttrs = { ...$attrs }
  delete myAttrs.class

  return myAttrs
})

const columnGap = computed(() => {
  if (props.colgap) {
    return {
      'grid-column-gap': `${props.colgap}rem`,
    }
  }
  else {
    return {
    }
  }
})

const wrap = ref()
</script>

<template>
  <div class="m-row" :class="{ debug }">
    <Wrap ref="wrap" :style="columnGap" :class="w" v-bind="filteredAttrs">
      <slot />
    </Wrap>
  </div>
</template>

<style lang="scss" scoped>
.m-row {
  >.m-wrap {
    width:100%;
    /* display:grid; */
    /*grid-auto-flow: column; */

    /* Represents the first child column of this element */
    &:slotted(> .m-col) {
      /* box-shadow: inset 0 0 0 1px black; */
    }
  }

  &:hover {
    /* box-shadow: inset 0 0 0 1px red; */
  }

  &.debug {
    >.m-wrap {
      box-shadow: inset 0 0 0 1px green;
      :deep(.m-col) {
        box-shadow: inset 0 0 0 1px purple;
      }
    }
  }
}
</style>
